import type {TextareaProps as ChakraTextareaProps} from '@chakra-ui/react';
import {forwardRef, Textarea as ChakraTextarea} from '@chakra-ui/react';
import type {TextareaAutosizeProps} from 'react-textarea-autosize';
import ResizeTextarea from 'react-textarea-autosize';

import {useAutoSizeTextareaStyleConfig} from '../../theme-config';

export type AutoResizeTextareaProps = ChakraTextareaProps & Omit<TextareaAutosizeProps, 'style'>;

export const AutoResizeTextarea = forwardRef<AutoResizeTextareaProps, 'textarea'>((props, ref) => {
  const styles = useAutoSizeTextareaStyleConfig(props);

  return <ChakraTextarea sx={styles} ref={ref} minRows={1} as={ResizeTextarea} {...props} />;
});
